import { END_POINT } from "@constants/api.constants";
import { PRIMARY_KEY } from "@constants/app.constants";
import { formatDateUtil } from "@utils/date.util";

const keyColumn = PRIMARY_KEY;
const tableTitle = "Menu Items";
const menuUrl = "system/menu-items";

const { MENU_ITEMS_STATUS_TOGGLE } = END_POINT;

const tableColumn = [
  {
    id: "menu_name",
    numeric: false,
    disablePadding: true,
    // inlineEdit: true,
    // width: 200,
    label: "Menu Name",
    sorting: true,
  },
  {
    id: "menu_url",
    numeric: false,
    disablePadding: false,
    // width: 200,
    label: "Menu Url",
    sorting: true,
  },
  {
    id: "menu_icon",
    numeric: false,
    disablePadding: false,
    label: "Menu Icon",
    // width: 180,
    sorting: true,
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    label: "Type",
    // width: 100,
    isBadge: true,
    sorting: true,
    badgeText: {
      1: "Menu",
      2: "Permission",
    },
    badgeColor: {
      1: "info",
      2: "warning",
    },
  },
  {
    id: "sort_order",
    numeric: false,
    // width: 120,
    disablePadding: false,
    label: "Sort Order",
    sorting: true,
  },
  {
    id: "role_view",
    numeric: false,
    disablePadding: false,
    label: "Status",
    // width: 100,
    isBadge: true,
    badgeClick: MENU_ITEMS_STATUS_TOGGLE,
    primaryKey: keyColumn,
    sorting: true,
    badgeText: {
      0: "Disabled",
      1: "Enabled",
    },
    badgeColor: {
      0: "danger",
      1: "success",
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    sorting: true,
    // width: 140,
    formatData: formatDateUtil,
  },
];
const breadCrumbs = [
  { name: "System", menu_url: null },
  { name: "Menu Items", menu_url: "/system/menu-items" },
];

const filters = [
  {
    name: "menu_name",
    id: "menu_name",
    label: "Menu Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
    // inputClass: "form-control-sm",
  },
  {
    name: "menu_url",
    id: "menu_url",
    label: "Menu Url",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

const tableConfig = {
  // actionWidth: 106,
};

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
  tableConfig,
};
